import React, { useEffect } from 'react';
import { getDataSession } from 'views/Utils/Common';
import { useLocation } from 'react-router';
import { AuthTienda } from './AuthTienda';
import { useUIUtils } from 'hooks/useUIUtils';

const MercadoLibre = ({ history, match, saludo, subtitulo }) => {
    let { search } = useLocation();
    let query = new URLSearchParams(search);
    let code = query.get('code');
    const { changeGlobalTitle } = useUIUtils()
    const id = getDataSession('sucursalMercadoLibre');

    useEffect(() => {
         changeGlobalTitle('Empresa'); 
    }, [changeGlobalTitle]);

    return (<AuthTienda history={history} tienda='MERCADOLIBRE' code={code} sucursal_id={id} isNoLogin={false}></AuthTienda>);
};

export { MercadoLibre };
